export const localeHeader = 'locale';
export const userIDHeader = 'user-id';
export const apiKeyHeader = 'x-api-key';
export const hubSpotWebhookSignature = 'x-hubspot-signature';
export const hubSpotSignatureVersion = 'x-hubspot-signature-version';
export const hubSpotWebhookSignatureV3 = 'x-hubspot-signature-v3';
export const hubSpotRequestTimestamp = 'x-hubspot-request-timestamp';
export const shopifyWebhookSignature = 'x-shopify-hmac-sha256';
export const shopifyApiVersion = 'x-shopify-api-version';
export const authorizationHeader = 'authorization';
export const flowRunEventID = 'ExecutionHistoryViewer';
export const responseEventID = 'simulation-result';
export function executionLogUpdateID(simEntityID: string) {
	return `execution-log-update-${simEntityID}`;
}
export const defaultVersionsOnlyIDKey = 'defaultVersionsOnly';
export const flowTypeKey = 'flowType';
export const allVersionsID = 'allVersions';
export const relatedStageOnlyKey = 'relatedStageOnly';
export const mfaToken = 'MFAToken';
export const projectSpaceIDKey = 'projectSpaceID';

export const taskExecutionQueueExchange = 'TaskExecution';
export const taskExecutionQueueName = 'TaskExecution';
export const taskExecutionResultQueueExchange = 'TaskExecutionResult';
export const taskExecutionResultQueueName = 'TaskExecutionResult';

export const taskStartExchangeName = 'TaskStart';
export const taskStartQueueName = 'TaskStart';

export function flowStateUpdateID(flowID: string) {
	return `flow-state-update-${flowID}`;
}
export const expressionStart = '<#';
export const expressionEnd = '#>';
export const SimulationSocketEndpoint = `ExecutionSimulator`;
export const ExecutionHistoryUpdateEndpoint = `ExecutionHistoryUpdate`;
export const TaskExecutorEndpoint = `TaskExecutor`;
export const fullRecordKey = 'Full-Record';
export const archiveConfigName = `3dfb0033-5c2d-4b15-b211-4818ee72ef34`;
export const uniqueHistoryConfigName = '31f4252f-43c4-401a-84c5-030220105b45';
export const dbBackupConfigName = `46085e12-8418-402f-95c6-c9671c75fd52`;
export const RestReceiverURLCacheKey = 'REST-URLS';
export const HubSpotWebhookURLCacheKey = 'HUBSPOT-WEBHOOK-URLS';
export const ShopifyWebhookURLCacheKey = 'SHOPIFY-WEBHOOK-URLS';
export const mdTenantID = '0196b547-9733-74e0-8b41-dd44079d0102';
/** The most executions a rate limiter holds in its backlog. A task can set a lower overflow threshold, never a higher one. */
export const rateLimiterMaxBacklogSize = 1000;

export const passwordSettingsID = '54f54724-23d4-4a90-add5-e5a47c80d157';
// UUID v7 format: xxxxxxxx-xxxx-7xxx-xxxx-xxxxxxxxxxxx
export const uuidV7Pattern =
	/^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

//Dashboards
//MainDashboard
export const mainDashboardConfigID = '019d914e-984a-76fb-898c-b13aaa95d3bf';
export const productionExecutionHistoryByClientID = '019d6d73-ce74-771c-8494-ddd011860ed3';
export const developExecutionHistoryByClientID = '019dd8de-731d-762b-b0fd-d5d33d354d94';
export const runStatesOverTimeID = '019d6d7f-aa8e-7358-8172-50ee4fc6805f';
export const top5AmountOfRunsByFlowID = '019d6d7f-aa8e-7602-bef9-aa400fb3bba3';
//ClientSpaceDashboard
export const productionExecutionHistoryByProjectID = '019dce9a-df5e-7979-b586-20148ef071bf';
export const developExecutionHistoryByProjectID = '019dce9a-df5e-7571-b08c-c944c945ef66';
//ProjectSpaceDashboard
export const productionExecutionHistoryByIntegrationID = '019dd8de-731d-7dce-8a75-ad85aac103cb';
export const developExecutionHistoryByIntegrationID = '019dd8de-731d-7471-820b-21c11713d8e8';
//Add Item Task
export const addToRootValue = 'Add-To-Root';
export const addAsRootValue = 'Add-As-Root';
// Scoped Permissions
export const scopedClientKey = 'x-client-key';
export const scopedProjectKey = 'x-project-key';
